import { render, staticRenderFns } from "./AccountUserData.vue?vue&type=template&id=240d2c80"
import script from "./AccountUserData.vue?vue&type=script&lang=js"
export * from "./AccountUserData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports